import axios from 'axios';
import LoginModel from './loginModel';
import LoginResult from './loginResult';
import RefreshModel from './refreshModel';

export const Login = (model: LoginModel, signal?: AbortSignal) => axios.post<LoginResult>('/api/Authentication/Login', model, { signal });

export const Refresh = (model: RefreshModel, signal?: AbortSignal) => axios.post<LoginResult>('/api/Authentication/Refresh', model, { signal });
